import z from 'zod';

export type AutoCompleteDto = {
	id: string;
	description: string;
};

export const AutoCompleteDtoSchema: z.ZodType<AutoCompleteDto> = z.object({
	id: z.string(),
	description: z.string(),
});
